export default {
  Invoices: {
    DESCRIPTION:
      'Review the recharges between entities. If anything needs editing, go back to the previous screen and update the rules applied.',
    INVOICES: 'Recharge Postings',
    POSTING_INTO: 'Posting into:',
    IN_CURRENCY: 'In currency:',
    Empty: {
      TITLE: 'No postings found',
      DESCRIPTION: 'There were no postings for this month. Go back to review how the transactions are being recharged in order to generate postings',
      REVIEW_TRANSACTIONS: 'Review Transactions',
    },
    Amount: {
      TAX_INCLUSIVE: '{{type}} is tax inclusive',
      TAX_EXCLUSIVE: '{{type}} is tax exclusive',
    },
    CsvOptions: {
      RAW: 'All transaction data',
      JOURNAL: 'Xero Journal Format ({{currency}})',
      SALES: 'Xero Sales Invoice Format ({{currency}})',
      PURCHASE: 'Xero Bill Format ({{currency}})',
    },
    NumberNotice: {
      TITLE: 'Invoice Number',
      BODY: "We've assigned this invoice number {{invoiceNumber}}. You can edit this once imported into Xero if you wish.",
      IGNORE: "Don't show this again",
      OK: 'Ok',
    },
    Currency: {
      RESET_RATE: 'Reset to the Fixer rate',
    },
  },
  Postings: {
    Types: {
      journal: 'Journal',
      invoice: 'Invoice',
      bill: 'Bill',
    },
    Options: {
      CREATE: 'Create',
      POST_AS: 'Post as',
      CURRENCY: 'Currency',
      INVOICE_NUMBER: 'Invoice number',
      GROUP_BY: 'Group by',
    },
    Dates: {
      DATE: 'Date',
      ISSUE: 'Issue date',
      DUE: 'Due date',
    },
  },
  TaxRates: {
    SET_ALL: 'Set all lines to {{rate}}',
    SET_SOME: 'Set all {{type}} lines to {{rate}}',
    CONFIRM_ALL: 'Set all lines in the {{postingType}} in {{entity}} to {{taxRate}}?',
    CONFIRM_SOME: 'Set all {{type}} lines in the {{postingType}} in {{entity}} to {{taxRate}}?',
  },
};
